module.exports = __webpack_public_path__ + "img/icon-switchboard.8b491d14.svg";